export default "__VITE_ASSET__EA9uuOSZ__"